import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientPayerApi } from '../api/patient-payers';
import { switchMap, map } from 'rxjs/operators';

import { PatientPayerData, PatientPayer } from '../../../interfaces/patient-services/patient-payer';

@Injectable()
export class PatientPayerMstService extends PatientPayerData {

    constructor(private api: PatientPayerApi) {
      super();
    }
  
  
    list(url: string): Observable<PatientPayer[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<any>{
        return this.api.getById(url);
    }
  
    create(url: string, data:PatientPayer): Observable<PatientPayer[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:PatientPayer): Observable<PatientPayer> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  